import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import Iconify from '@/components/iconify';
import { fDateTime } from '@/utils/formatTime';

// O tema capitaliza cada palavra do botao, o que vira "Voltar Para O Painel
// Principal". A tela escreve em frase, como o card de reprovado.
const BOTAO_EM_FRASE = { textTransform: 'none' };

const StepDot = ({ done }) => (
  <Box
    sx={{
      width: 20,
      height: 20,
      flexShrink: 0,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'common.white',
      bgcolor: done ? 'primary.main' : 'transparent',
      border: (theme) => `solid 2px ${theme.palette.primary.main}`,
    }}
  >
    {done && <Iconify icon="eva:checkmark-fill" width={12} />}
  </Box>
);

StepDot.propTypes = {
  done: PropTypes.bool,
};

export default function BusinessInReviewCard({ submittedAt, onBackToMain }) {
  return (
    <Card sx={{ p: { xs: 3, md: 4 } }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
        <Box
          sx={{
            width: 56,
            height: 56,
            flexShrink: 0,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'secondary.main',
            bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.16),
          }}
        >
          <Iconify icon="solar:clock-circle-bold" width={28} />
        </Box>

        <Stack spacing={3} sx={{ flexGrow: 1 }}>
          <Stack spacing={1}>
            <Typography variant="h5">Estamos analisando o seu novo negócio</Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Nossa equipe de Compliance está analisando os dados informados para o cadastro da
              empresa. Após a aprovação, você poderá começar a operar este negócio na plataforma.
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="flex-start" spacing={2}>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <StepDot done />
                <Box sx={{ flexGrow: 1, height: 2, bgcolor: 'primary.main' }} />
              </Stack>

              <Typography variant="subtitle2">Dados enviados</Typography>

              {submittedAt && (
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {fDateTime(submittedAt)}
                </Typography>
              )}
            </Stack>

            <Stack spacing={1} sx={{ flex: 1 }}>
              <StepDot />

              <Typography variant="subtitle2">Em análise</Typography>

              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Prazo estimado: 2 dias úteis
              </Typography>
            </Stack>
          </Stack>

          {/* Quem sabe se existe outro negocio liberado e a tela; sem destino, o
              botao levaria a esta mesma tela, entao ele nem aparece. */}
          {onBackToMain && (
            <Stack direction={{ xs: 'column', sm: 'row' }}>
              <Button
                variant="contained"
                onClick={onBackToMain}
                startIcon={<Iconify icon="eva:arrow-back-fill" />}
                sx={BOTAO_EM_FRASE}
              >
                Voltar para o painel principal
              </Button>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}

BusinessInReviewCard.propTypes = {
  submittedAt: PropTypes.string,
  onBackToMain: PropTypes.func,
};
